import { render, staticRenderFns } from "./SharingEntryLink.vue?vue&type=template&id=10855e60&scoped=true&"
import script from "./SharingEntryLink.vue?vue&type=script&lang=js&"
export * from "./SharingEntryLink.vue?vue&type=script&lang=js&"
import style0 from "./SharingEntryLink.vue?vue&type=style&index=0&id=10855e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10855e60",
  null
  
)

export default component.exports